module.exports = __webpack_public_path__ + "static/media/dashboard-on-nick.29d79c51.svg";